import { Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { CopyIconButton } from "@/components/copyButton";
import { BackButton } from "@/components/button";
import { WarehouseAutoTuneControl } from "./WarehouseAutoTuneControl";
import WarehouseAutoTuneBadges from "./WarehouseAutoTuneBadges";
import type { WarehouseDetails, WarehouseAutoTuneConfiguration } from "@/pages/warehouse/types";

interface WarehouseDetailsHeaderProps {
  warehouseDetails: WarehouseDetails;
  autoTuneConfiguration: WarehouseAutoTuneConfiguration;
}

const WarehouseDetailsHeader = ({
  warehouseDetails,
  autoTuneConfiguration,
}: WarehouseDetailsHeaderProps) => {
  return (
    <Stack direction="row" align="center" className="al-w-full al-border-b al-pb-4">
      <Stack align="start" className="al-flex-1">
        <BackButton defaultUrl="/warehouse" className={"al-w-auto"} />
        <Stack direction="column" gap="none">
          <Stack align="center">
            <Typography variant="section-heading">{warehouseDetails.warehouse_name}</Typography>
            <CopyIconButton
              value={warehouseDetails.warehouse_name}
              colorClassName="al-text-primary"
            />
          </Stack>
          <WarehouseAutoTuneBadges
            warehouseRK={warehouseDetails.warehouse_rk}
            autoTuneConfiguration={autoTuneConfiguration}
          />
        </Stack>
      </Stack>

      <WarehouseAutoTuneControl
        warehouseRK={warehouseDetails.warehouse_rk}
        warehouseName={warehouseDetails.warehouse_name}
        defaultWarehouseSize={warehouseDetails.default_warehouse_size}
        autoTuneConfiguration={autoTuneConfiguration}
      />
    </Stack>
  );
};

export default WarehouseDetailsHeader;
